// Shared inline styles for the four portal auth screens. Inline rather than new App.css classes
// because these are the only screens that use them and they'd otherwise sit in a stylesheet every
// internal page also downloads. Colors come from App.css custom properties either way, so the
// portal can't drift from the rest of the app (CLAUDE.md Section 1).

export const page = {
  maxWidth: 420,
  margin: '0 auto',
  paddingTop: 96,
  paddingLeft: 20,
  paddingRight: 20,
};

export const subtitle = {
  fontSize: 13,
  color: 'var(--text-mid)',
  marginBottom: 32,
  textAlign: 'center',
};

export const heading = {
  fontSize: 16,
  fontWeight: 600,
  color: 'var(--text-dark)',
  marginBottom: 6,
};

export const helpText = {
  fontSize: 13,
  color: 'var(--text-mid)',
  lineHeight: 1.6,
  marginBottom: 20,
};

export const submitButton = {
  width: '100%',
  padding: 12,
  fontSize: 14,
  justifyContent: 'center',
  marginTop: 4,
};

export const errorBox = {
  marginBottom: 16,
  padding: '12px 16px',
  borderRadius: 8,
  fontSize: 13,
  lineHeight: 1.5,
  background: 'rgba(239,65,54,0.08)',
  border: '1px solid rgba(239,65,54,0.3)',
  color: 'var(--red)',
};

export const noticeBox = {
  marginBottom: 16,
  padding: '12px 16px',
  borderRadius: 8,
  fontSize: 13,
  lineHeight: 1.5,
  background: 'var(--light-bg)',
  border: '1px solid var(--border)',
  color: 'var(--text-mid)',
};

export const linkButton = {
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  fontSize: 13,
  color: 'var(--heading)',
  textDecoration: 'underline',
  cursor: 'pointer',
};

export const footerRow = {
  marginTop: 20,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
};
